import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

// THUNK
export const getServicesList = createAsyncThunk(
    'services/getServices',
    async ({ accountId, token, start = 0, length = 10, draw = 1, order = [], columns = [] }, { rejectWithValue }) => {
    try {
        console.log('getServicesList - accountId:', accountId);
        console.log('getServicesList - token:', token ? 'presente' : 'non presente');
        console.log('getServicesList - start:', start);
        console.log('getServicesList - length:', length);
        
        // Costruisco l'URL con tutti i parametri necessari
        let url = `${import.meta.env.VITE_API_BASE_URL}/services/list?accountId=${accountId}&start=${start}&length=${length}&draw=${draw}`;
        
        // Non passiamo il parametro search al server, la ricerca testuale viene fatta lato client
        
        // Aggiungo i parametri order e columns se necessario
        if (order && order.length > 0) {
            order.forEach((ord, index) => {
                url += `&order[${index}][column]=${ord.column}&order[${index}][dir]=${ord.dir}`;
            });
        }
        
        if (columns && columns.length > 0) {
            columns.forEach((col, index) => {
                url += `&columns[${index}][data]=${col.data}`;
            });
        }
        const headers = {
            'Content-Type': 'application/json',
            'auth-token': token
        };
        const options = { method: 'GET', headers };
        
        console.log('getServicesList - URL:', url);
        console.log('getServicesList - headers:', JSON.stringify(headers));
        
        const response = await fetch(url, options);
        console.log('getServicesList - response status:', response.status);
        
        if (!response.ok) {
            const error = await response.json();
            console.error('getServicesList - error:', error);
            return rejectWithValue({
                message: error.message || `Errore sconosciuto.`
            })
        }
        const result = await response.json();
        console.log('getServicesList - result:', result);
        return result
    } catch (error) {
        console.error('getServicesList - catch error:', error);
        return rejectWithValue({
            message: (error instanceof Error) ? error.message : 'Errore di rete. Riprova più tardi.'
        });
    }
})

const initialState = {
    data: null,
    isLoading: false,
    error: null
};

const servicesSlice = createSlice({
    name: 'services',
    initialState,
    reducers: {
        clearServicesData: (state) => {
            state.data = null;
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getServicesList.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getServicesList.fulfilled, (state, action) => {
                state.data = action.payload;
                state.error = null
                state.isLoading = false;
            })
            .addCase(getServicesList.rejected, (state, action) => {
                state.error = action.payload?.message || "Errore sconosciuto nel caricamento della lista servizi.";
                state.isLoading = false;
            })
    }
});

// Selector
export const selectServicesData = (state) => state.services.data;
export const selectServicesLoading = (state) => state.services.isLoading;
export const selectServicesError = (state) => state.services.error;

export const { clearServicesData } = servicesSlice.actions;
export default servicesSlice.reducer;
